import $ from 'jquery';
import Component from '../Component';

export default class QuickAdd extends Component {
  constructor(theme, element) {
    super(theme, element);

    this.theme = theme;
    this.element = element;
    this.onSubmit = this.onSubmit.bind(this);
    this.currentButton = null;
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.languageUrl = document.getElementById('PageContainer').dataset.languageUrl;
    this.formWrapper = /** @type {HTMLElement} */ (this.element.querySelectorAll('.quick-add-wrapper.is-singular'));
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);

    if (!this.formWrapper) {
      return;
    }

    Array.prototype.forEach.call(
      this.element.querySelectorAll('.quick-add-wrapper.is-singular .shopify-product-form'),
      (el) => {
        el.addEventListener('submit', this.onSubmit);
      },
    );
  }

  async onSubmit(e) {

    // Go straight to cart page, use html form submit event.
    if(this.cartAction == 'page') {
      return;
    }

    e.preventDefault();

    this.currentButton = e.currentTarget.querySelector('.quick-add-button');

    // Loading spinner.
    this.currentButton.innerHTML = `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" class="spin flex-full"><g clip-path="url(#clip0_3605_47041)"><path d="M12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 15.1767 22.1534 18.0388 20 20.0468" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g><defs><clipPath id="clip0_3605_47041"><rect width="24" height="24" fill="none" transform="translate(0.5)"/></clipPath></defs>${ this.translationsObject.translations.loading }</svg>`;
    try {
      const data = $(e.currentTarget).serialize();
      const response = await window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data,
      });
      if (!response.ok) {
        // FIXME: error handling
        return false;
      }

      const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
      const response2 = await window.fetch(`${languageParam}/cart.js`);
      if (!response2.ok) {
        // FIXME: error handling
        return false;
      }
      const cart = await response2.json();

      if(this.cartAction == 'drawer') {
        this.theme.toggleRightDrawer('cart', true, { cart: cart });
      }
      else {
        this.currentButton.innerHTML = this.translationsObject.translations.productAdded;
        this.theme.updateCartDrawer(cart);
      }

      setTimeout(() => {
        this.currentButton.innerHTML = this.translationsObject.translations.addToCart;
      }, 2000);

    } catch (e) {
      console.error('Unable to add to cart: ', e);
      // FIXME error handling
    }

    return false;
  }
}
